import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "min-h-screen max-h-screen w-screen flex relative lg:static bg-surface-0"
};
var _hoisted_2 = {
  class: "min-h-screen max-h-screen flex-1 flex flex-col overflow-auto"
};
var _hoisted_3 = {
  class: "p-5 flex-auto overflow-auto w-full h-full content-container relative"
};
import SideMenu from "@/components/menu/SideMenu.vue";
import TopMenu from "@/components/menu/TopMenu.vue";
import { ConfirmDialog } from "primevue";
export default {
  __name: 'AppLayout',
  props: {
    showSidebar: {
      type: Boolean,
      default: true
    }
  },
  setup: function setup(__props) {
    var props = __props;
    return function (_ctx, _cache) {
      var _component_router_view = _resolveComponent("router-view");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [__props.showSidebar ? (_openBlock(), _createBlock(SideMenu, {
        key: 0
      })) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_2, [__props.showSidebar ? (_openBlock(), _createBlock(TopMenu, {
        key: 0
      })) : _createCommentVNode("", true), _cache[0] || (_cache[0] = _createElementVNode("div", {
        id: "secondary-menu"
      }, null, -1)), _createElementVNode("div", _hoisted_3, [_createVNode(_component_router_view), _createVNode(_unref(ConfirmDialog))]), _cache[1] || (_cache[1] = _createElementVNode("div", {
        id: "page-footer"
      }, null, -1))])]);
    };
  }
};